import React from 'react';
import { ActionLinks } from 'components/ActionLinks/ActionLinks';
import { Callout } from 'components/layout/Callout';
import { IActionLinkItem } from 'components/ActionLinks/ActionLinkModels';
import { Loading } from 'components/Loading';
import classNames from 'classnames';
export interface IPortalActionLinkItem extends IActionLinkItem {
  order: number;
}
export interface IPortalActionsMenuProps extends React.HTMLProps<{}> {
  isOpen: boolean;
  email: string;
  timeZone?: string;
  actions: IActionLinkItem[];
  sourceRef: React.MutableRefObject<HTMLElement | null>;
  onClose: () => void;
  loading?: boolean;
  backdropIsVisible?: boolean;
}

const preventPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => e.stopPropagation();

/**
 * Actions menu where user email and actions are displayed.
 *
 * Copyright (c) 2019 Decisions All Rights Reserved
 */
export function PortalActionsMenu({
  backdropIsVisible,
  className,
  onClose,
  actions: propActions,
  isOpen,
  sourceRef,
  email,
  timeZone,
  loading,
}: IPortalActionsMenuProps) {
  const actions = propActions.map(action => ({
    ...action,
    onClick: () => {
      action.onClick!();
      onClose();
    },
  }));

  return (
    <Callout
      className={getActionsClassName(className)}
      isOpen={isOpen}
      onClose={onClose}
      sourceRef={sourceRef}
      placement="bottom-end"
      backdropIsVisible={backdropIsVisible}
    >
      <div className={'dpc-portal-actions-menu__user-info'} onClick={preventPropagation}>
        <span className="dpc-portal-actions-menu__email">{email}</span>
        {!!timeZone && <span className={'dpc-portal-actions-menu__time-zone'}>{timeZone}</span>}
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className={'dpc-portal-actions-menu__actions'}>
          <ActionLinks
            values={{
              current: actions,
            }}
            translateLabels={true}
          />
        </div>
      )}
    </Callout>
  );
}

function getActionsClassName(className?: string) {
  return classNames('dpc-portal-actions-menu', className);
}
